module.exports = __webpack_public_path__ + "img/tlf_sum2.29474233.png";